import React, { ReactNode } from 'react';
import styles from './StatusIndicator.module.scss';

interface StatusIndicatorProps {
  background: string;
  text: string;
  icon?: ReactNode;
  className?: string;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  background,
  text,
  icon,
  className,
}) => {
  return (
    <div className={`${styles.blockCircle} ${className || ''}`}>
      {icon ? icon : <div className={styles.circle} style={{ background }} />}
      <p style={{ color: background }}>{text}</p>
    </div>
  );
};
